module.exports = __webpack_public_path__ + "img/design-team.d7ce4c6d.webp";